import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { ILinkedExecutionQuery } from '../interfaces/linked-execution.query.interface';

// @dynamic
export class LinkedExecution {
    id: string;
    name: string;
    status?: string;
    kind: string;
    image: MaxbrainImage;
    version: string;
    participantCount: number;
    type: string;
    isManager?: boolean;
    selfPaced: boolean;

    constructor(query: ILinkedExecutionQuery) {
        this.id = query.id.toString();
        this.name = query.name;
        this.status = query.status;
        this.kind = query.kind;
        this.image = query.image ? new MaxbrainImage(query.image) : null;
        this.version = query.version;
        this.participantCount = query.participant_count;
        this.type = query.type;
        this.isManager = query.is_manager;
        this.selfPaced = query.self_paced;
    }
}

